import { render } from "./ViewBotConfiguration.vue?vue&type=template&id=717a7e04&scoped=true"
import script from "./ViewBotConfiguration.vue?vue&type=script&lang=js"
export * from "./ViewBotConfiguration.vue?vue&type=script&lang=js"

import "./ViewBotConfiguration.vue?vue&type=style&index=0&id=717a7e04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717a7e04"]])

export default __exports__